module.exports = "<div class=\"et-settings-panel\" ng-controller=\"blockEditDialogCtrl\" tabindex=\"3\"><div class=\"et-sw-wrapper\" ng-tabs=\"\" ng-if=\"settings.body\"><div class=\"etsw-body\" ng-html-compile=\"settings.body\" ng-class=\"{'str-shake-it': shakeIt}\"></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/pug-html-loader/lib!./src/app/editor/editor_nav/blocksettings.jade
// module id = 313
// module chunks = 0